import { useFlags } from "launchdarkly-react-client-sdk";

import { RouteConfig } from "services/routesConfig";

import { useSideNavGroups, useTopLevelNavItems } from "./hooks";
import Sidebar from "./Sidebar";

interface Props {
  expanded: boolean;
  setExpanded: (expanded: boolean) => void;
  toggleExpand: () => void;
  routeConfig: RouteConfig;
}

const SidebarNav = ({
  expanded,
  setExpanded,
  toggleExpand,
  routeConfig,
}: Props) => {
  const flags = useFlags();
  const navItems = useTopLevelNavItems({ flags });
  const navGroups = useSideNavGroups({ flags });

  return (
    <Sidebar
      navItems={navItems}
      navGroups={navGroups}
      expanded={expanded}
      setExpanded={setExpanded}
      toggleExpand={toggleExpand}
      routeConfig={routeConfig}
      showHomeLink
    />
  );
};

export default SidebarNav;
